import { LocationSourceEnum } from '@mark43/cad-api';
import { groupBy, sortBy } from 'lodash';
import type { LocationStoreView } from '../types/locations';

export interface GroupedLocationData {
    esriCustomItems: LocationStoreView[];
    mark43Items: LocationStoreView[];
    esriItems: LocationStoreView[];
    latLngItems: LocationStoreView[];
    forcedResults: LocationStoreView[];
    renderedList: LocationStoreView[];
}

/**
 * Groups and sorts location items into the order they are rendered in the UI.
 * Returns both grouped arrays (for rendering with headers) and a flat list (for index mapping).
 */
export function buildRenderedLocationList(list: LocationStoreView[]): GroupedLocationData {
    const grouped = groupBy(
        list,
        ({ source, resolverSource }: LocationStoreView) => {
            if (
                source === 'FORCED_LOCATION' &&
                resolverSource !== LocationSourceEnum.LAT_LONG.name
            ) {
                return 'forcedResults';
            }

            switch (source) {
                case 'ESRI':
                    return 'esriItems';
                case 'ESRI_CUSTOM':
                    return 'esriCustomItems';
                case 'LAT_LONG':
                    return 'latLngItems';
                default:
                    return 'mark43Items';
            }
        }
    );

    const esriCustomItems = grouped.esriCustomItems ?? [];
    const esriItems = grouped.esriItems ?? [];
    const latLngItems = grouped.latLngItems ?? [];
    const forcedResults = grouped.forcedResults ?? [];
    // Forced subpremise results are sorted to the bottom of mark43Items
    const mark43Items = sortBy(grouped.mark43Items ?? [], 'isForcedSubpremiseResult');

    const renderedList = [
        ...esriCustomItems,
        ...mark43Items,
        ...esriItems,
        ...latLngItems,
        ...forcedResults,
    ];

    return {
        esriCustomItems,
        mark43Items,
        esriItems,
        latLngItems,
        forcedResults,
        renderedList,
    };
}
